import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";
import { FormActions } from "./FormActions";

export function Page({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex h-full min-h-0 flex-col overflow-hidden bg-background", className)}
      {...props}
    />
  );
}

export function PageContent({
  className,
  padded = true,
  ...props
}: ComponentProps<"div"> & { padded?: boolean }) {
  return (
    <div
      className={cn("mx-auto min-h-0 w-full max-w-[960px] flex-1 overflow-y-auto overscroll-contain [scrollbar-gutter:stable] [scroll-padding-block:16px]", padded && "px-4 pb-6 pt-2 sm:px-[30px]", className)}
      {...props}
    />
  );
}

export function PageFooter({
  children,
  narrow = false,
  contentClassName,
}: {
  children: ReactNode;
  narrow?: boolean;
  contentClassName?: string;
}) {
  return (
    <footer aria-label="Page actions" className="shrink-0 border-t border-border bg-card px-4 py-3">
      <FormActions className={cn("mx-auto w-full max-w-[900px] border-0 p-0 [&>button]:h-12", narrow && "max-w-md sm:[&>button]:flex-1 sm:[&>a]:flex-1", contentClassName)}>
        {children}
      </FormActions>
    </footer>
  );
}
